var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.show)?_c('div',{staticClass:"toast",class:_vm.position},[_c('div',{staticClass:"text"},[_vm._v(_vm._s(_vm.options.message))])]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }